/**
 * [ File :: B_Child.js ]
 *
 * @경로 : /public/scripts/game/lcPlugIn/canvas/base/dev/child/base/B_Child.js
 * @목적 : 
 * @설명 : 
 * @진행 : 
 * @주의 :
 * @이슈 :
 * @일자 : 2018.mm.dd
 * @작성 : SuperMoon
 * @참조 :
 */

import B_Util from 'canvas/base/dev/util/B_Util';
import B_Define from 'canvas/base/dev/util/B_Define';
import { isDist } from 'canvas/base/dev/util/B_Config';

const B_Child = (function(){

	// 필드 명세
    const $ = {
	    _id : null,     // 아이디 {str}
	    _type : null,   // 타입 {str}
	    _active : null, // 활성화 {bool}
	    _enable : null  // 삭제화 {bool}
    };

	class B_Child {

		constructor(obj) {
			try {

				// [E] obj 체크
				if(typeof obj == 'undefined') {
					B_Util.print(B_Define.MESSAGE['NO_PARAM']);
					return;
				}

				// [E] obj.cm 체크
				if (typeof obj.cm == 'undefined') {
					B_Util.print(B_Define.MESSAGE['NO_CANVAS_OBJECT']);
					return;
				} else this.CODMOS = obj.cm;

				// [E] obj.id 체크
				if (typeof obj.id == 'undefined') {
					B_Util.print(B_Define.MESSAGE['NO_OBJECT_ID']);
					return;
				} else this._id = obj.id;

				// [E] obj.type 체크
				if (typeof obj.type == 'undefined') {
					// [E] res 참조속성처리
					if (obj.res) {
						obj.type = this._checkRes(obj.type, this.CODMOS._res[obj.res].type, null);
					}

					if (typeof obj.type == 'undefined') {
						B_Util.print("[코드모스] => 요청 객체 \'" + obj.id + "\' 의 Type이 없습니다.");
						return;
					}
				}
				this._type = obj.type;

				// [E] obj.active
				if (obj.active == undefined) obj.active = true;
				this._active = obj.active;

				// [S] enable
				this._enable = true;
			} catch (e) {
				B_Util.print('[코드모스] => B_Child - ' + e)
			}
		}

		// [V] public

		// @DES :: id {str}
		get id() { return this._id; }

		// @DES :: type {str}
		get type() { return this._type; }

		// [F]

		/**
		 * @DES :: 객체제거
		 * @S.E ::
		 */
		_remove() { }
		
	}

	// [#] watcher & unwatcher 설정

	if (!B_Child.prototype._watch)
		B_Child.prototype._watch = function (prop, handler) {
			var oldval = this[prop], newval = oldval,
				getter = function () {
					return newval;
				},
				setter = function (val) {
					oldval = newval;
					return newval = handler.call(this, prop, oldval, val);
				};
			if (delete this[prop]) { // can't watch constants
				if (Object.defineProperty) // ECMAScript 5
					Object.defineProperty(this, prop, {
						get: getter,
						set: setter
					});
				else if (B_Child.prototype.__defineGetter__ && B_Child.prototype.__defineSetter__) {
					B_Base.prototype.__defineGetter__.call(this, prop, getter);
					B_Base.prototype.__defineSetter__.call(this, prop, setter);
				}
			}
		};

	if (!B_Child.prototype._unwatch)
		B_Child.prototype._unwatch = function (prop) {
			var val = this[prop];
			delete this[prop]; // remove accessors
			this[prop] = val;
		};

	B_Util.manageGetAndSet(B_Child, $);
	return B_Child;
}());

export default B_Child;


// WEBPACK FOOTER //
// ./src/assets/js/codmos/game/lcPlugIn/canvas/base/dev/child/base/B_Child.js